import React from 'react';

export default function ({ highlightsfeed, eleRef }) {
    return (
<div>
  {eleRef.state.loggedin &&
<section className="main_container_block_feeds">
<div className="main_block_container_feed">
   <div className="block_container_feed_heading_text R15_61">
     <span className="dny-b-15">{highlightsfeed ?highlightsfeed.title:''}</span> updates
    </div>
    <div className="content-div-box-artical">
     <div className="due_date_Calculater_main_style"> 
        <div className="content-div_view_artical">
          {/* <img src={highlightsfeed.data && highlightsfeed.data[0] ? highlightsfeed.data[0].imageUrl:'https://cdn.cdnparenting.com/brainbees/community/homeimages/right_breastfeedng.jpeg'} alt="logo"/> */}
          <img src="https://cdn.cdnparenting.com/brainbees/community/homeimages/right_breastfeedng.jpeg" alt="right breastfeeding" title="right breastfeeding"/>
        </div>
      </div>
    
    <div className="breastfeeding_bg_content">
           <div className="breastfeeding_view"> 
                <div className="last_period_view_text mr_b4"> 
                   <div className="left_last_period_12 M14_21"> 
                      <span className="breast_icon_D"> 
                       <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/calendar.png" alt="last updated date" title="last updated date"/>
                      </span> Last Updated Date :
                    </div>
                   <div className="right_last_period_12 M14_21">{highlightsfeed.userData && highlightsfeed.userData[0] && highlightsfeed.userData[0].feedSummary && highlightsfeed.userData[0].feedSummary[0] ? highlightsfeed.userData[0].feedSummary[0].createdDate : ''}</div>
                </div>
                <div className="last_period_view_text"> 
                   <div className="breast_feeding_121 brea_mr_b14">
                       <div className="left_last_period_12 M14_21"> 
                          <span className="breast_icon_D"> 
                           {/* <img src={highlightsfeed.icon ? highlightsfeed.icon : ''} alt="logo"/> */}
                           <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/leftBreast.png" alt="left breast" title="left breast"/>
                          </span> {highlightsfeed.userData && highlightsfeed.userData[0] && highlightsfeed.userData[0].feedSummary && highlightsfeed.userData[0].feedSummary[0] ? highlightsfeed.userData[0].feedSummary[0].feedType : ''} :
                        </div>
                       <div className="right_last_period_12 M14_21">{highlightsfeed.userData && highlightsfeed.userData[0] && highlightsfeed.userData[0].feedSummary && highlightsfeed.userData[0].feedSummary[0] ? highlightsfeed.userData[0].feedSummary[0].totalFeedDuration : ''} sec </div>
                   </div>
                   <div className="breast_feeding_121">
                       <div className="left_last_period_12 R14_42"> 
                          <span className="breast_icon_D"> 
                           <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Clock-grey.png" alt="time" title="time"/>
                          </span> time  :
                        </div>
                       <div className="right_last_period_12 R14_42"> {highlightsfeed.userData && highlightsfeed.userData[0] && highlightsfeed.userData[0].feedSummary && highlightsfeed.userData[0].feedSummary[0] ? highlightsfeed.userData[0].feedSummary[0].actualFeedingTime : ''} </div>
                   </div>
                </div>
                <div className="btn_group_join_common kick_counter_common_btn contest_winner-btns-360">
                  <a href={(highlightsfeed.data && highlightsfeed.data[0])?highlightsfeed.data[0].redirectionUrl:'https://parenting.firstcry.com/tools/breastfeeding-tracker/'} tabIndex={0} aria-label='Record breastfeeding session'>
                   <button className="M16_white text_uppercase" type="button" aria-hidden="true" tabIndex={-1}>{highlightsfeed.data && highlightsfeed.data[0] ? highlightsfeed.data[0].buttonText:highlightsfeed.dataApp[0].buttonText}</button>
                   </a>
                </div>
              </div>
            </div>
    </div>
</div>
</section>
}
</div>
    )
}
